import React from 'react';
// Import the image from your local assets folder
import transformingImage from '../img/envision/digital/image-removebg-preview.png';

const Digitalpagesection = () => {
  return (
    <div id="hs_cos_wrapper_widget_1672835526724" className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_module" style={{background:'#000'}}>
      <div className="cd-two-col-wrp widget_1672835526724" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div className="container" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <div className="cd-two-col-in" style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <div className="cd-two-col-imag" style={{ flex: 1 }}>
              {/* Use the imported image here */}
              <img
                src={transformingImage}
                alt="Transforming Engineering And Research Development by Delivering Digital Engineering and Delivering Digital Engineering"
                loading="lazy"
                width="886"
                height="757"
                style={{ maxWidth: '100%', height: 'auto' }}
              />
            </div>
            <div className="cd-two-col-txt" style={{ order: 0, flex: 1, paddingLeft: '20px', color:"#fff", marginTop:"100px" }}>
              <h3 style={{color:"#fff"}}>Transforming ER&D by <br /> Delivering Digital Engineering <br />@ Scale</h3>
              <p style={{color:"#fff", textAlign:'justify' }}>
                The advent of intelligent and connected products has ushered in a new era for ER&D. Moving beyond the traditional focus areas of concept design, manufacture, and <span>aftermarket</span>, ER&D companies are also tracking product-customer interactions at multiple levels, forming the ‘enterprise product digital thread’ throughout the product’s lifecycle.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Digitalpagesection;
